/**
 * Las rutas de la autenticacion y a donde se vuelve despues de ingresar.
 *
 * Vive aparte de `lib/auth.tsx` para que una pantalla publica (la home, "este
 * negocio no existe") pueda enlazar al ingreso sin cargar nada de la sesion.
 */

export const SIGN_IN_PATH = "/ingresar";
export const SIGN_UP_PATH = "/registro";
export const PANEL_PATH = "/panel";

/**
 * A donde volver despues de ingresar o registrarse, o `null`.
 *
 * Solo a rutas propias con forma conocida: una invitacion, el panel o el alta.
 * Es lo que impide que `?volver=` sirva para mandar a alguien, ya con su sesion
 * iniciada, a un sitio que imita a TurnPro. La API aplica la misma regla a la
 * vuelta de Google (`safeReturnPath`).
 */
export function destinoSeguro(volver: string | null): string | null {
  if (!volver) return null;
  if (/^\/invitacion\/[A-Za-z0-9_-]{20,100}$/.test(volver)) return volver;
  if (volver === "/crear-negocio") return volver;
  if (/^\/panel(\/[a-z0-9-]+){0,3}$/.test(volver)) return volver;
  return null;
}

const CLAVE_DESTINO = "turnpro:volver";

/**
 * El destino de `?volver=`, recordado durante la pestaña.
 *
 * Ingresar puede pasar por varias pantallas (el codigo del correo, el segundo
 * factor, la ida y vuelta a Google) y no hay garantia de que la consulta
 * sobreviva a todas. Si se pierde, la persona termina en el alta de un negocio
 * en lugar de en su invitacion. Se guarda en `sessionStorage` y la pantalla de
 * la invitacion lo borra al abrirse: ya llego.
 */
export function destinoDeRegreso(volver: string | null): string | null {
  const directo = destinoSeguro(volver);
  try {
    if (directo) {
      sessionStorage.setItem(CLAVE_DESTINO, directo);
      return directo;
    }
    return destinoSeguro(sessionStorage.getItem(CLAVE_DESTINO));
  } catch {
    // Sin almacenamiento (modo privado estricto): queda lo que vino en la URL.
    return directo;
  }
}

export function olvidarDestino(): void {
  try {
    sessionStorage.removeItem(CLAVE_DESTINO);
  } catch {
    // Nada que borrar si no hay donde guardar.
  }
}
